module.exports = {
    useBarcodeScannerOutput: () => [null]
};
